module.exports = __webpack_public_path__ + "img/wutu1.6659cc6c.png";